import {Layout, Typography} from 'antd';
import React from 'react';
import AuthForm from './AuthForm';

const {Content} = Layout;
const {Title} = Typography;

const Auth = () => (
  <Layout className="login-layout">
    <Content className="login-content">
      <Title level={1}>MONEI Wallet</Title>
      <AuthForm />
    </Content>
  </Layout>
);

export default Auth;
